// src/components/snapshot/strategy-brief/StrategyBriefCTA.tsx

import { Sparkles } from 'lucide-react';

type Props = {
  headline: string;
  supportingCopy: string;
  buttonLabel: string;
};

export function StrategyBriefCTA({ headline, supportingCopy }: Props) {
  return (
    <section className="rounded-2xl border border-[#18365E]/15 bg-gradient-to-br from-white to-[#18365E]/6 shadow-sm overflow-hidden">
      <div className="p-6 sm:p-7">
        <div className="flex items-start gap-5">
          <div className="h-12 w-12 rounded-2xl bg-[#18365E] flex items-center justify-center flex-shrink-0 shadow-sm">
            <Sparkles className="h-6 w-6 text-white" />
          </div>

          <div className="min-w-0 flex-1">
            <h2 className="text-xl font-extrabold text-[#18365E] tracking-tight">
              {headline}
            </h2>
            <p className="text-sm text-[#18365E]/80 leading-relaxed mt-2 max-w-2xl">
              {supportingCopy}
            </p>
          </div>
        </div>
      </div>

      <div className="px-6 sm:px-7 pb-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {[
            { k: 'Ranked', v: 'Initiative Portfolio' },
            { k: 'Modeled', v: 'ROI & Payback' },
            { k: 'Aligned', v: 'Execution Roadmap' },
          ].map((item) => (
            <div
              key={item.k}
              className="rounded-xl bg-white/80 border border-[#E5E7EB] px-4 py-3"
            >
              <div className="text-[11px] font-semibold text-[#717182] uppercase tracking-wide">
                {item.k}
              </div>
              <div className="text-sm font-bold text-[#18365E] mt-0.5">
                {item.v}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
